var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"layout-container"},[_c('plane',{ref:"ceiling",attrs:{"reverse":"","src":_vm.src,"size":_vm.size},on:{"load":_vm.ceilingLoaded}}),_c('plane',{ref:"floor",attrs:{"pincushion":"","src":_vm.src,"size":_vm.size},on:{"load":_vm.floorLoaded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }